import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import Main from "./layouts/Main";
import Home from "./pages/Home/Home";
import Setting from "./pages/Home/Setting/Setting";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function App() {
  const theme = createTheme({
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "white",
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          dense: {
            minHeight: 32,
          },
        },
      },
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route
              element={
                <Main>
                  <Outlet />
                </Main>
              }
            >
              <Route index element={<Home />} />
              <Route path="/setting" element={<Setting />} />
              <Route path="/about" element={<h1>About</h1>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
